import { headerBlocks } from "./receipt-template.js";
export const tableReportPrintFor = (input) => {
    const blocks = headerBlocks({
        company: input.company,
        template: input.template,
    });
    blocks.push({ kind: 'rule' }, {
        kind: 'text',
        text: input.title.toUpperCase(),
        align: 'center',
        bold: true,
    }, { kind: 'rule' });
    for (const filter of input.filters) {
        blocks.push({ kind: 'pair', label: filter.label, value: filter.value });
    }
    if (input.summary.length > 0) {
        blocks.push({ kind: 'rule' });
        for (const line of input.summary) {
            blocks.push({
                kind: 'pair',
                label: line.label,
                value: line.value,
                ...(line.bold === true ? { bold: true } : {}),
            });
        }
    }
    for (const note of input.notes ?? []) {
        blocks.push({ kind: 'text', text: note });
    }
    for (const section of input.sections) {
        blocks.push({ kind: 'rule' }, { kind: 'text', text: section.title, bold: true }, {
            kind: 'table',
            columns: section.columns,
            rows: section.rows,
            ...(section.footer === undefined ? {} : { footer: section.footer }),
        });
    }
    blocks.push({ kind: 'feed', lines: 2 }, { kind: 'cut' });
    return { kind: 'report', title: input.title, blocks };
};
//# sourceMappingURL=table-report.js.map